import { ChannelForm } from './ChannelForm';
import { v4 as uuid } from 'uuid';
import { Channel, EPGData } from '../../../models/channel';
import { ChannelFormData } from '../../../pages/channelmanager/channels/channel-editor/ChannelFormData';
import { compressionUtils } from '../../../utils/compressionUtils';
import calendarUtils from '../../../utils/calendarUtils';
import { clone, cloneDeep, cloneDeepWith, orderBy, uniqBy } from 'lodash';
import { EventForm } from '../../../components/FuelCalendarContainer';
import { toIcsString } from '../../../components/FuelCalendarContainer/toIcsString';
import clientUtils from '../../../utils/clientUtils';
import { Item } from '../../../models';

export class EpgConfigData {
  // parentForm: ChannelForm = null;
  entityType: string = 'EPGData';
  targetChannelId: string = null;
  iCalendarConfig: string = null;
  decodedICalendarConfig: string = null;
  id: string = null;
  epgData: EPGData | any;
  events: any = [];
  hasChange: boolean = false;
  backstopFillerChannelId: string = null;
  entityOuId: string | null = null;
  clipIds:string[] = [];

  static create(parentForm: ChannelForm): EpgConfigData {
    const form = new EpgConfigData();
    // form.parentForm = parentForm;
    return form;
  }

  static createFromData(parentForm: ChannelForm, data: ChannelFormData): EpgConfigData {
    const form = new EpgConfigData();
    // form.parentForm = parentForm;
    form.loadData(data);
    return form;
  }

  private constructor() {}

  loadData(data: ChannelFormData) {
    // console.log('EpgConfigData.loadData', { data });
    const { channel } = data;
    if (channel) {
      if (channel.id) {
        this.targetChannelId = channel.id;
        this.entityOuId = channel.ouId;

        if (data.epgData && data.epgData) {
          this.epgData = data.epgData;
          this.id = data.epgData.id;
          this.iCalendarConfig = data.epgData.iCalendarConfig;
          this.decodedICalendarConfig = calendarUtils.decodeICalendarConfig(
            data.epgData.iCalendarConfig,
            data.epgData.isCompressed
          );
          if (this.decodedICalendarConfig) {
            const daysToKeep = channel.metaData?.epgConfig?.daysToKeep ? channel.metaData?.epgConfig?.daysToKeep : 7;
            this.events = calendarUtils.getEventsFromICS(this.decodedICalendarConfig, data.channel.timezone, daysToKeep);
          }
          // console.log('EpgConfigData.loadData', this);
        }
        if (
          channel.metaData &&
          channel.metaData.fillers &&
          channel.metaData.fillers.Backstop &&
          channel.metaData.fillers.Backstop.length > 0
        ) {
          this.backstopFillerChannelId = channel.metaData.fillers.Backstop[0];
        }
      }
    }
  }

  static generateEPGData(form: ChannelForm, newEpgForm: EpgConfigData, timezone: string): EPGData {
    // if (channel == null || clientUtils.isNullOrWhitespace(channel.id)) {
    //   throw `Channel id cannot be null or empty when saving epg data, channel: ${channel}`;
    // }
    // console.log('generateEPGData', { channelId, newEpgForm, timezone, daysToKeep });
    let isCompressed = false;
    let data: string | null = null;
    if (newEpgForm.events && newEpgForm.events.length > 0) {
      let newEvents = uniqBy(newEpgForm.events, 'id');
      let iCalendarConfig2 = toIcsString(newEvents, timezone);

      data = compressionUtils.base64Encode(iCalendarConfig2);

      // aalt 2024-09-30 #2499 Prod Error - EPG data too large for DynamoDB. Check length after bas64Encoding the data, as it can increase overall bytes eg. length 200526 -> 267368
      if (data.length > 200000) {
        isCompressed = true;
        data = compressionUtils.compress(iCalendarConfig2);
      }
    }
    // if (newEpgForm.iCalendarConfig) {
    //   // aalt 2022-08-08 Need to format the times with timezone to parse correctly in Ical.Net
    //   // DTSTART;TZID="America/Los_Angeles":20220808T160000
    //   const iCalendarConfig2 = newEpgForm.iCalendarConfig
    //     .replace(/DTSTART:/g, `DTSTART;TZID="${timezone}":`)
    //     .replace(/DTEND:/g, `DTEND;TZID="${timezone}":`);
    //   if (iCalendarConfig2.length > 200000) {
    //     isCompressed = true;
    //     data = compressionUtils.compress(iCalendarConfig2);
    //   } else {
    //     data = compressionUtils.base64Encode(iCalendarConfig2);
    //   }
    // }

    const ePGData: EPGData = {
      isCompressed,
      entityType: 'EPGData',
      id: newEpgForm.id,
      targetChannelId: form.id,
      iCalendarConfig: data,
      entityOuId: form.ouId,
    };

    // console.log('generateEPGData', { ePGData });
    return ePGData;
  }
}
